var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"health"},[_c('div',{staticClass:"status"},[_vm._v("OK")]),_c('div',{staticClass:"message"},[_vm._v("Service is healthy")]),_c('div',{staticClass:"timestamp"},[_vm._v(_vm._s(_vm.currentTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }